export const APIPrefix = '/consignor/recovery/admin/recovery-group';